
function NotificationIcon({ color }: { color: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="31"
      fill="none"
      viewBox="0 0 32 31"
    >
      <g filter="url(#filter0_b_3358_9493)">
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M23.913 20.708a4.068 4.068 0 01-1.357-1.314 4.275 4.275 0 01-.643-1.81v-3.126a7.5 7.5 0 00-1.168-3.703 7.09 7.09 0 00-2.832-2.547c0-.552-.21-1.082-.586-1.473a1.96 1.96 0 00-1.414-.61c-.53 0-1.04.22-1.414.61-.375.39-.586.92-.586 1.473a7.091 7.091 0 00-2.832 2.547 7.5 7.5 0 00-1.168 3.703v3.125a4.276 4.276 0 01-.643 1.81 4.069 4.069 0 01-1.357 1.315m16 0h-16m16 0h-5m-11 0h5m0 0v1.042c0 .829.316 1.624.879 2.21a2.94 2.94 0 002.121.915 2.94 2.94 0 002.121-.915c.563-.586.88-1.381.88-2.21v-1.042m-6 0h6"
        ></path>
        <path
          fill={color}
          d="M14.499 6.735c-.375.39-.586.92-.586 1.473a7.091 7.091 0 00-2.832 2.547 7.5 7.5 0 00-1.168 3.703v3.125a4.276 4.276 0 01-.643 1.81 4.069 4.069 0 01-1.357 1.315h16a4.068 4.068 0 01-1.357-1.314 4.275 4.275 0 01-.643-1.81v-3.126a7.5 7.5 0 00-1.168-3.703 7.09 7.09 0 00-2.832-2.547c0-.552-.21-1.082-.586-1.473a1.96 1.96 0 00-1.414-.61c-.53 0-1.04.22-1.414.61zM18.913 20.708h-6v1.042c0 .829.316 1.624.879 2.21a2.94 2.94 0 002.121.915 2.94 2.94 0 002.121-.915c.563-.586.88-1.381.88-2.21v-1.042z"
        ></path>
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18.913 20.708h5a4.068 4.068 0 01-1.357-1.314 4.275 4.275 0 01-.643-1.81v-3.126a7.5 7.5 0 00-1.168-3.703 7.09 7.09 0 00-2.832-2.547c0-.552-.21-1.082-.586-1.473a1.96 1.96 0 00-1.414-.61c-.53 0-1.04.22-1.414.61-.375.39-.586.92-.586 1.473a7.091 7.091 0 00-2.832 2.547 7.5 7.5 0 00-1.168 3.703v3.125a4.276 4.276 0 01-.643 1.81 4.069 4.069 0 01-1.357 1.315h5m6 0h-6m6 0v1.042c0 .829-.316 1.624-.879 2.21a2.94 2.94 0 01-2.12.915 2.94 2.94 0 01-2.122-.915 3.192 3.192 0 01-.879-2.21v-1.042"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_b_3358_9493"
          width="79"
          height="79"
          x="-23.587"
          y="-24"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur
            in="BackgroundImageFix"
            stdDeviation="12"
          ></feGaussianBlur>
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_3358_9493"
          ></feComposite>
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3358_9493"
            result="shape"
          ></feBlend>
        </filter>
        <clipPath id="clip0_3358_9493">
          <rect
            width="9"
            height="10"
            x="17.913"
            y="1"
            fill={color}
            rx="4.5"
          ></rect>
        </clipPath>
      </defs>
    </svg>
  );
}

export default NotificationIcon;
